export const FALLBACK_COLLAGE_PRODUCTS = [
  { id: "mini", label: "Mini recuerdo", cols: 2, rows: 2 },
  { id: "standard", label: "Estándar", cols: 3, rows: 3 },
  { id: "premium", label: "Premium", cols: 3, rows: 4 },
  { id: "vertical", label: "Vertical", cols: 3, rows: 5 },
  { id: "large", label: "Grande", cols: 4, rows: 4 },
  { id: "max", label: "Maxi collage", cols: 4, rows: 5 },
];